"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var schema_1 = require("./schema");
var configurator_1 = require("../configurator");
var prosemirror_state_1 = require("prosemirror-state");
var event_1 = require("../event");
// for remove useless tags to user
var SYL_TAG = '__syl_tag';
exports.SYL_TAG = SYL_TAG;
var SELECT_CLS = 'syl-selected-card';
// use config to generate schemaMeta,
function configuration(_config) {
    return function setCardMeta(card) {
        var config = _config;
        var type = Reflect.getMetadata(schema_1.FLAG, card);
        if (!type || !schema_1.SylSchema.isCard(card)) {
            console.warn("config with not card type!");
            return card;
        }
        // if uniqKey is `true`, use name as uniqKey's value
        if (config.uniqKey === true) {
            config.uniqKey = Symbol.for(config.name);
        }
        if (schema_1.SylSchema.isInline(card)) {
            config = Object.assign(new schema_1.InlineAtom(), config);
        }
        else {
            // 块级卡片默认设置isolating属性
            config = Object.assign(new schema_1.BlockAtom(), { isolating: true }, config);
        }
        // 是否是sylCard,用于点击选中的默认行为
        if (config.sylCard === undefined) {
            config.sylCard = true;
        }
        // 是否需要选中后才能拖动，因为pm默认选不中nodeView，所以修改默认值为true
        if (config.draggable === undefined) {
            config.draggable = true;
        }
        var meta = new schema_1.SchemaMeta(type, config.name, config);
        Reflect.defineMetadata(schema_1.META, meta, card);
        return card;
    };
}
exports.configuration = configuration;
var createCursorFixer = function () {
    var dom = document.createElement('span');
    dom.className = 'syl-inline-fixer';
    dom.appendChild(document.createTextNode('\u200B'));
    return dom;
};
// define all of the basic property of nodeView
var BaseCard = /** @class */ (function () {
    function BaseCard(adapter, node) {
        var _this = this;
        var rest = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            rest[_i - 2] = arguments[_i];
        }
        this.dom = document.createElement('span');
        this.isSelected = false;
        this.traceSelection = true;
        // 不同接入层的renderer组件
        this.renderer = null;
        this.traceSelect = function () {
            var selection = _this.adapter.view.state.selection;
            if (selection instanceof prosemirror_state_1.NodeSelection)
                return;
            if (selection.empty && _this.isSelected) {
                _this.deselectNode();
            }
            else {
                var pos = _this.getPos();
                var from = selection.from, to = selection.to;
                if (from <= pos && pos < to) {
                    !_this.isSelected && _this.selectNode();
                }
                else if (_this.isSelected) {
                    _this.deselectNode();
                }
            }
        };
        this.getPos = function () {
            var getPos = configurator_1.unwrapNodeView(_this).getPos;
            return getPos();
        };
        this.getNode = function () {
            var _a = configurator_1.unwrapNodeView(_this), view = _a.view, getPos = _a.getPos;
            return view.state.tr.doc.nodeAt(getPos());
        };
        this.attrs = node.attrs;
        this.adapter = adapter;
        this.traceSelection = !(node.type.spec.traceSelection === false);
        if (this.traceSelection) {
            this.adapter.on(event_1.EventChannel.LocalEvent.SELECTION_CHANGED, this.traceSelect);
        }
    }
    BaseCard.prototype.update = function (_a) {
        var attrs = _a.attrs, isSelected = _a.isSelected, isText = _a.isText;
        // do update attrs
        return false;
    };
    BaseCard.prototype.selectNode = function () {
        // 未选中状态下更新数据，选中之后会把更新的attrs重置
        var currentNode = this.getNode();
        if (currentNode)
            this.attrs = currentNode.attrs;
        this.update({
            attrs: this.attrs,
            isSelected: true
        });
        this.isSelected = true;
        this.dom.classList.add(SELECT_CLS);
        return false;
    };
    BaseCard.prototype.deselectNode = function () {
        // 如果selectNode到deselectNode过程中修改了attrs
        // 但没有调用dispatchUpdate，deselectNode会把更新的attrs重置
        var currentNode = this.getNode();
        if (currentNode)
            this.attrs = currentNode.attrs;
        this.update({
            attrs: this.attrs,
            isSelected: false
        });
        this.isSelected = false;
        this.dom.classList.remove(SELECT_CLS);
        return;
    };
    BaseCard.prototype.mount = function (_a) {
        var name = _a.name;
        console.error('[SylEditor Warning]: this error usually means you do not' +
            'import Card/InlineCard from access layer' +
            'do not import from @syl-editor/core-utilities directly');
    };
    BaseCard.prototype.error = function (msg) {
        if (msg === 'duplicated') {
            console.error('multiple blot has been created', this);
        }
        console.error(msg);
    };
    BaseCard.prototype.afterMount = function (name) {
        this.fixCursor(name);
    };
    BaseCard.prototype.fixCursor = function (name) {
        var curNode = this.adapter.view.state.schema.nodes[name];
        if (!curNode || !curNode.spec.fixCursor)
            return;
        this.dom.insertBefore(createCursorFixer(), this.dom.firstElementChild);
        this.dom.appendChild(createCursorFixer());
    };
    // 返回相对于editor.root的位置
    BaseCard.prototype.getBoundingClientRect = function () {
        var domRect = this.dom.getBoundingClientRect();
        var rootRect = this.adapter.root.getBoundingClientRect();
        return __assign(__assign({}, JSON.parse(JSON.stringify(domRect))), { top: domRect.top - rootRect.top, left: domRect.left - rootRect.left, bottom: domRect.bottom - rootRect.top, right: domRect.right - rootRect.left });
    };
    BaseCard.prototype.dispatchUpdate = function (attrs) {
        var _a = configurator_1.unwrapNodeView(this), view = _a.view, getPos = _a.getPos;
        // update attrs
        this.attrs = attrs;
        view.dispatch(view.state.tr.setNodeMarkup(getPos(), undefined, attrs));
    };
    BaseCard.prototype.ignoreMutation = function (event) {
        // return true
    };
    BaseCard.prototype.stopEvent = function () {
        // return true
    };
    BaseCard.prototype.destroy = function () {
        if (this.traceSelection) {
            this.adapter.off(event_1.EventChannel.LocalEvent.SELECTION_CHANGED, this.traceSelect);
        }
        // return true
    };
    return BaseCard;
}());
exports.BaseCard = BaseCard;
var createElement = function (tagName) {
    var container = document.createElement(tagName);
    container.setAttribute(SYL_TAG, 'true');
    return container;
};
var createCardDOM = function () { return createElement('div'); };
exports.createCardDOM = createCardDOM;
var createInlineCardDOM = function () { return createElement('syl-inline'); };
exports.createInlineCardDOM = createInlineCardDOM;
var Card = /** @class */ (function (_super) {
    __extends(Card, _super);
    function Card() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dom = createCardDOM();
        return _this;
    }
    Card = __decorate([
        Reflect.metadata(schema_1.FLAG, schema_1.FORMAT_TYPE.BLOCK_CARD)
    ], Card);
    return Card;
}(BaseCard));
exports.Card = Card;
var InlineCard = /** @class */ (function (_super) {
    __extends(InlineCard, _super);
    function InlineCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dom = createInlineCardDOM();
        return _this;
    }
    InlineCard = __decorate([
        Reflect.metadata(schema_1.FLAG, schema_1.FORMAT_TYPE.INLINE_CARD)
    ], InlineCard);
    return InlineCard;
}(BaseCard));
exports.InlineCard = InlineCard;
//# sourceMappingURL=card.js.map